import styles from '@/shared/test-env-indicator/index.module.css';

const testEnv = process.env.REACT_APP_TEST_ENV === 'true';
const isStaging = typeof window !== 'undefined' && window.location.hostname.includes('staging');
const envLabel = isStaging ? 'staging' : 'test env';

export default function TestEnvIndicator({ compact }: { compact?: boolean }) {
  if (!testEnv) return null;

  return (
    <span className={compact ? styles.badgeCompact : styles.badgeBar}>
      <span className={styles.emoji}>⚠️</span> {envLabel}
    </span>
  );
}
